module.exports = __webpack_public_path__ + "static/furniture-recent-posts-section-317f374ed33dcffc3acd125340ae4a16.png";